export const priorityItemTitleMap = {
    creditScore: 'Credit score',
    transactions: 'Transactions',
    analytics: 'Analytics & budgeting',
    subscriptions: 'Recurring payments',
    groups: 'Groups',
    cashback: 'Cashback offers',
    completeSetup: 'Complete setup',
};
export const tabPriorityItemTitleMap = {
    // GB
    save: 'Save',
    pay: 'Pay',
    invest: 'Invest',
    borrow: 'Credit',
    // US_CA
    networth: 'Networth',
    budgeting: 'Budgeting',
    recurring: 'Recurring',
    groups: 'Groups',
};
/**
 * Single source of truth mapping a navigator route name to its
 * personalisation key. Most match by lowercasing, but four differ
 * (NetworthTab→networth, BudgetingTab→budgeting, RecurringTab→recurring,
 * GroupTab→groups). Consumed by useTabNavigation and the tab-bar surfaces.
 */
export const TAB_ROUTE_TO_KEY = {
    // GB
    Save: 'save',
    Pay: 'pay',
    Invest: 'invest',
    Borrow: 'borrow',
    // US_CA
    NetworthTab: 'networth',
    BudgetingTab: 'budgeting',
    RecurringTab: 'recurring',
    GroupTab: 'groups',
};
export const TAB_KEY_TO_ROUTE = Object.fromEntries(Object.entries(TAB_ROUTE_TO_KEY).map(([route, key]) => [key, route]));
export const defaultFeedPriorityArr = [
    'creditScore', // GB
    'transactions',
    'analytics',
    'subscriptions',
    'groups', // GB, behind remove_pay_tab
    'cashback', // US_CA
    'completeSetup',
];
export const defaultTabPriority = {
    // GB
    save: 1,
    pay: 2,
    invest: 3,
    borrow: 4,
    // US_CA
    networth: 1,
    budgeting: 2,
    recurring: 3,
    groups: 4,
};
